export default __webpack_public_path__ + "static/media/36I-102716_-15719_0.91078594.jpg";